export function WalletSectionError({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center h-40 gap-3">
      <p className="text-red-500 text-sm">{message}</p>
      <button
        onClick={onRetry}
        className="px-4 py-2 text-sm text-white bg-[#1E61DC] rounded-lg hover:bg-[#1a55c4] transition-colors"
      >
        Retry
      </button>
    </div>
  );
}
